<template>
  <el-dialog
    :visible.sync="visible"
    :title="!dataForm.cartoonCode ? '新增视频' : '编辑视频'"
    width="720px"
    :close-on-click-modal="false"
    :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" label-position="top">
      <el-form-item label="标题" prop="cartoonName">
        <el-input v-model="dataForm.cartoonName" placeholder="如：极品身材小姐姐深夜直播精彩片段合集"></el-input>
      </el-form-item>

      <el-form-item label="标签">
        <el-select
          v-model="tagIds"
          multiple
          filterable
          placeholder="国产, 直播, 精选（最多 3 个）"
          style="width: 100%;"
          :multiple-limit="maxTags">
          <el-option
            v-for="tag in tagList"
            :key="tag.id"
            :label="tag.name"
            :value="tag.id">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="封面图" prop="cartoonImage">
        <ImageUpload
          :limit="1"
          v-model="dataForm.cartoonImage"
          :file-size="5"
          :file-type="['png', 'jpg', 'jpeg', 'gif', 'webp']"
          :is-show-tip="false"
        />
      </el-form-item>

      <el-form-item label="播放地址" prop="playUrl">
        <el-input v-model="dataForm.playUrl" placeholder="视频 URL 或加密地址"></el-input>
      </el-form-item>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="是否 VIP" prop="cartoonVip">
            <el-select v-model="dataForm.cartoonVip" placeholder="请选择" style="width: 100%;">
              <el-option label="是" :value="1"></el-option>
              <el-option label="否" :value="0"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="单片价格" prop="onePrice">
            <el-input v-model="dataForm.onePrice" placeholder="留空则使用默认 ¥4"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="排序权重" prop="sort">
            <el-input v-model="dataForm.sort" placeholder="100"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <template slot="footer">
      <el-button type="primary" :loading="submitting" @click="dataFormSubmitHandle()">保存</el-button>
      <el-button @click="visible = false">取消</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
import {
  getMovieTagPage,
  getMovieTags,
  updateMovieTags,
  getMovieEpisodes,
  saveMovieEpisode,
  MAX_TAGS_PER_MOVIE
} from '@/api/movie'

export default {
  data () {
    return {
      visible: false,
      submitting: false,
      // 电影标签：与视频主体分两个接口保存
      tagList: [],
      tagIds: [],
      originalTagIds: [],
      // 播放地址取自分集表，记录原分集用于回写
      episode: null,
      originalPlayUrl: '',
      dataForm: {
        cartoonCode: '',
        cartoonName: '',
        cartoonImage: '',
        playUrl: '',
        cartoonVip: '',
        onePrice: '',
        sort: 100
      }
    }
  },
  computed: {
    maxTags () {
      return MAX_TAGS_PER_MOVIE
    },
    dataRule () {
      return {
        cartoonName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        playUrl: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.tagIds = []
      this.originalTagIds = []
      this.episode = null
      this.originalPlayUrl = ''
      this.loadTags()
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.cartoonCode) {
          this.getInfo()
          this.getTags()
          this.getPlayUrl()
        } else {
          this.dataForm.cartoonImage = ''
        }
      })
    },

    loadTags () {
      return getMovieTagPage({ page: 1, limit: 200 }).then(({ data: res }) => {
        if (res.code !== 0) {
          return
        }
        this.tagList = (res.data && res.data.list) || []
      }).catch(() => {})
    },

    getInfo () {
      this.$http.get(`/movies/movies/${this.dataForm.cartoonCode}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },

    // 已有视频的标签单独取
    getTags () {
      return getMovieTags(this.dataForm.cartoonCode).then(({ data: res }) => {
        if (res.code !== 0) {
          return
        }
        const ids = (res.data || []).map(item => item.id)
        this.tagIds = ids
        this.originalTagIds = [...ids]
      }).catch(() => {})
    },

    tagsChanged () {
      if (this.tagIds.length !== this.originalTagIds.length) {
        return true
      }
      return this.tagIds.some(id => !this.originalTagIds.includes(id))
    },

    // 播放地址取该视频排序最靠前的一条分集
    getPlayUrl () {
      return getMovieEpisodes(this.dataForm.cartoonCode).then(({ data: res }) => {
        if (res.code !== 0) {
          return
        }
        const list = (res.data && res.data.list) || []
        if (!list.length) {
          return
        }
        const first = [...list].sort((a, b) => (Number(a.sorts) || 0) - (Number(b.sorts) || 0))[0]
        this.episode = first
        this.dataForm.playUrl = first.url || ''
        this.originalPlayUrl = this.dataForm.playUrl
      }).catch(() => {})
    },

    // 回写播放地址：已有分集则更新，没有则新建一条
    savePlayUrl (cartoonCode) {
      const url = (this.dataForm.playUrl || '').trim()
      if (!url || url === this.originalPlayUrl) {
        return Promise.resolve()
      }
      const payload = this.episode
        ? { ...this.episode, url }
        : {
          url,
          name: '正片',
          sorts: 0,
          charge: this.dataForm.cartoonVip === 1 ? 1 : 0,
          cartoonCode
        }
      return saveMovieEpisode(payload).then(({ data: res }) => {
        if (res.code !== 0) {
          this.$message.warning(`视频已保存，但播放地址更新失败：${res.msg}`)
        }
      })
    },

    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.submitting = true
        const isAdd = !this.dataForm.cartoonCode
        // playUrl 存在分集表，不提交给视频接口
        const { playUrl, ...payload } = this.dataForm

        this.$http[isAdd ? 'post' : 'put']('/movies/movies/', payload).then(async ({ data: res }) => {
          if (res.code !== 0) {
            return Promise.reject(new Error(res.msg))
          }
          // 新增时若接口返回了新视频 ID 就能继续存标签和播放地址
          const code = isAdd
            ? (res.data && (res.data.cartoonCode || res.data.id || res.data))
            : this.dataForm.cartoonCode
          const validCode = code && typeof code !== 'object' ? code : ''

          if (!validCode) {
            this.$message.warning('视频已创建，但接口未返回视频 ID，请在列表中编辑该视频以补充标签和播放地址')
            return
          }
          if (this.tagsChanged()) {
            const { data: tagRes } = await updateMovieTags(validCode, this.tagIds)
            if (tagRes.code !== 0) {
              this.$message.warning(`视频已保存，但标签更新失败：${tagRes.msg}`)
            }
          }
          await this.savePlayUrl(validCode)
        }).then(() => {
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(e => {
          if (e && e.message) {
            this.$message.error(e.message)
          }
        }).finally(() => {
          this.submitting = false
        })
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
